var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnReadFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.677 2.898H2.3a1.4 1.4 0 00-1.4 1.4v8.4a1.4 1.4 0 001.4 1.4h11.4a1.4 1.4 0 001.4-1.4V6.8c-.354.266-.76.466-1.2.583v5.315a.2.2 0 01-.2.2H2.3a.2.2 0 01-.2-.2V4.786l5.123 3.416a1.4 1.4 0 001.553 0l2.114-1.41a3.518 3.518 0 01-.828-.89L8.11 7.204a.2.2 0 01-.222 0L3.232 4.098h6.27a3.539 3.539 0 01.175-1.2z",
    fill: "#7D8085"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 1.9,
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/unRead_folder.7f9d8944.svg";
export { SvgUnReadFolder as ReactComponent };